// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"453":"gift","594":"about","661":"gift-detail","699":"art-trade","720":"heritage","996":"cultural-mall"}[chunkId] || chunkId) + "." + {"438":"efdb3704","453":"e6c6cc51","457":"922c4e4d","594":"82ea4a66","661":"5c0df4c2","699":"2b92571e","720":"78b57436","996":"632ca597"}[chunkId] + ".js";
};